import api from "./api";
import {mapPublicHolidayDto} from "../dto/PublicHolidayDTO";

export const getPublicHolidays = async () => {
    try {
        const res = await api.get('/PublicHoliday');
        console.log(res.data);
        return res.data.map(mapPublicHolidayDto);
    } catch (err) {
        console.error("Error receiving holiday:", err);
        throw err;
    }
}

export const deletePublicHoliday = async (public_holiday_id) => {
    try {
        const result = await api.delete(`/PublicHoliday/${public_holiday_id}`);
        return result.data;
    } catch (err) {
        console.error("Error deleting holiday:", err);
        throw err;
    }
}


export const addPublicHoliday = async (publicHoliday) => {
    try {
        const res = await api.post('/PublicHoliday', publicHoliday);
        return res.data;
    } catch (err) {
        console.error("Error adding holiday:", err);
        throw err;
    }
};